import React, { useCallback, useEffect, useState } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../FirebaseConfig';
import VerifyCallerIdModal from './VerifyCallerIdModal';
import './PhoneVerificationGate.css';

const PhoneVerificationGate = ({ currentUser }) => {
  const [loaded, setLoaded] = useState(false);
  const [verified, setVerified] = useState(false);
  const [prompted, setPrompted] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (!currentUser) return;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'users', currentUser.uid));
        if (snap.exists()) {
          const data = snap.data();
          setVerified(Boolean(data.phone_verified_number));
          setPrompted(Boolean(data.phone_verify_prompted));
          setEmail(data.email || currentUser.email || '');
          setPhone(data.phone_number || '');
        } else {
          setEmail(currentUser.email || '');
        }
      } catch (err) {
        console.warn('PhoneVerificationGate: user doc load failed', err);
      } finally {
        setLoaded(true);
      }
    })();
  }, [currentUser]);

  useEffect(() => {
    if (!loaded) return;
    if (!verified && !prompted) {
      setModalOpen(true);
    }
  }, [loaded, verified, prompted]);

  const markPrompted = useCallback(async () => {
    if (!currentUser || prompted) return;
    try {
      await updateDoc(doc(db, 'users', currentUser.uid), { phone_verify_prompted: true });
    } catch (err) {
      console.warn('PhoneVerificationGate: failed to mark prompted', err);
    }
    setPrompted(true);
  }, [currentUser, prompted]);

  const handleClose = useCallback(() => {
    setModalOpen(false);
    markPrompted();
  }, [markPrompted]);

  const handleSuccess = useCallback(() => {
    // Mark verified so the banner hides immediately, but leave the modal
    // mounted — the user still needs to see the success view and click Done.
    // Closing the modal is handled by handleClose below.
    setVerified(true);
  }, []);

  if (!loaded || !currentUser) return null;

  return (
    <>
      {!verified && (
        <div className="pvg-banner" role="status">
          <span>Your phone number is not verified yet. Verify now to help with automated authentication and so callbacks reach you.</span>
          <button type="button" className="pvg-banner-btn" onClick={() => setModalOpen(true)}>
            Verify now
          </button>
        </div>
      )}
      <VerifyCallerIdModal
        isOpen={modalOpen}
        onClose={handleClose}
        currentUser={currentUser}
        onSuccess={handleSuccess}
        initialEmail={email}
        initialPhone={phone}
      />
    </>
  );
};

export default PhoneVerificationGate;
